/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Terms_Emptytitle1Inputs */

const en_welcome_terms_emptytitle1 = /** @type {(inputs: Welcome_Terms_Emptytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents to review`)
};

/**
* | output |
* | --- |
* | "No documents to review" |
*
* @param {Welcome_Terms_Emptytitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_terms_emptytitle1 = /** @type {((inputs?: Welcome_Terms_Emptytitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Terms_Emptytitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_terms_emptytitle1(inputs)
});
export { welcome_terms_emptytitle1 as "welcome_terms_emptyTitle" }